import { render, staticRenderFns } from "./Classics.vue?vue&type=template&id=a8d0fdfa&scoped=true"
import script from "./Classics.vue?vue&type=script&lang=js"
export * from "./Classics.vue?vue&type=script&lang=js"
import style0 from "./Classics.vue?vue&type=style&index=0&id=a8d0fdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d0fdfa",
  null
  
)

export default component.exports